import { __extends } from "tslib";
import { DeleteObjectsOutput, DeleteObjectsRequest } from "../models/index";
import { deserializeAws_restXmlDeleteObjectsCommand, serializeAws_restXmlDeleteObjectsCommand, } from "../protocols/Aws_restXml";
import { getApplyMd5BodyChecksumPlugin } from "@aws-sdk/middleware-apply-body-checksum";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteObjectsCommand = /** @class */ (function (_super) {
    __extends(DeleteObjectsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteObjectsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteObjectsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        this.middlewareStack.use(getApplyMd5BodyChecksumPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: DeleteObjectsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DeleteObjectsOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteObjectsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlDeleteObjectsCommand(input, context);
    };
    DeleteObjectsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlDeleteObjectsCommand(output, context);
    };
    return DeleteObjectsCommand;
}($Command));
export { DeleteObjectsCommand };
//# sourceMappingURL=DeleteObjectsCommand.js.map